export default "__VITE_ASSET__6bf547bb__"